import api from 'Application/api/api';

const getMeteocontrolSystems = async signal =>
	api.get('/meteocontrol/systems', {
		signal,
	});

export default getMeteocontrolSystems;
